import { BaseEntity } from 'yt-ng-framework';

export class KomitentObjekatUpisnoMestoView extends BaseEntity {
    constructor(){
        super();
    }
    NazivUpisnogMesta: string = null;
    KomitentNaziv: string = null;
    NazivObjekta: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.NazivUpisnogMesta = input.NazivUpisnogMesta;
        this.KomitentNaziv = input.KomitentNaziv;
        this.NazivObjekta = input.NazivObjekta;
        return this;
    }

    Serialize(input: KomitentObjekatUpisnoMestoView){
        return input;
    }
}